import gql from "graphql-tag";

const VERIFY_UNLOCK_TRANSACTION = gql`
    mutation verifyUnLockTokenTransaction(
        $lockTokenId: String!
        $trxHash: String!
        $walletAddress: String!
    ) {
        verifyUnLockTokenTransaction(
            verifyTrxInput: {
                lockTokenId: $lockTokenId
                trxHash: $trxHash
                walletAddress: $walletAddress
            }
        )   {
            id
            walletAddress
            duration
            tickets
            totalToken
            lockTrxHash
            unlockTrxHash
            isVerified
            lockedAt
            expiresAt
            status
            userId
        }
    }
`;

export default VERIFY_UNLOCK_TRANSACTION;